import { render } from "./NationalitySelector.vue?vue&type=template&id=bf49cfa4"
import script from "./NationalitySelector.vue?vue&type=script&lang=js"
export * from "./NationalitySelector.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__